



import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CREATE_Call_DISPOSITION_URl, CREATE_PRODUCT_URl, DELETE_Call_DISPOSITION_URl, DELETE_PRODUCT_URl, GET_Call_DISPOSITION_URl, GET_PRODUCTS_URl, UPDATE_Call_DISPOSITION_URl, UPDATE_PRODUCT_URl, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetProducts = createAsyncThunk('getProduct', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_PRODUCTS_URl, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            
            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetProductsSlice = createSlice({
    name: 'Product',
    initialState: {
        Product: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetProducts.fulfilled, (state, action) => {
                state.Product = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetProducts.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const GetProductDetialsSlice = createSlice({
    name: 'Product Details ',
    initialState: {
        product: ''
    },
    reducers: {
        setProductDetials: (state, action) => {
            state.product = action.payload;
        }
    }
});

export const CreateProduct = createAsyncThunk('CreateCall', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_PRODUCT_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', ' Product Created successfully.')
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateProduct = createAsyncThunk('updatemenu', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_PRODUCT_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'Product updated successfully.')

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteProduct = createAsyncThunk('deletMenu', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_PRODUCT_URl, { productID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'Product Deleted successfully.')

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const {setProductDetials} = GetProductDetialsSlice.actions
export {
    GetProductsSlice,
    GetProductDetialsSlice
};
